import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "report-recordings-comp" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createVNode("h1", null, "No Recordings", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", null, "It doesn't look like this report has any recordings.", -1)
const _hoisted_5 = {
  width: "300",
  height: "50",
  controls: ""
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Your browser does not support the video tag. ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Download")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_link = _resolveComponent("el-link")
  const _component_el_table = _resolveComponent("el-table")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.recordings.length == 0)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4
        ]))
      : (_openBlock(), _createBlock(_component_el_table, {
          key: 1,
          data: _ctx.recordings,
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, { type: "index" }),
            _createVNode(_component_el_table_column, {
              label: "Question",
              prop: "question"
            }),
            _createVNode(_component_el_table_column, {
              label: "Audio",
              width: "350"
            }, {
              default: _withCtx(({ row: recording }) => [
                _createVNode("video", _hoisted_5, [
                  _createVNode("source", {
                    src: recording.url,
                    type: "video/mp4"
                  }, null, 8, ["src"]),
                  _hoisted_6
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "Download" }, {
              default: _withCtx(({ row: recording }) => [
                _createVNode(_component_el_link, {
                  type: "primary",
                  href: recording.url
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 2
                }, 1032, ["href"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]))
  ]))
}